module.exports = __webpack_public_path__ + "static/media/artunity-mockup-5.c33c07bc.jpg";